import { startOfYear, endOfYear, addMonths, differenceInMonths, endOfMonth } from 'date-fns';

const createLabel = (label, period) => {
  if(!label) {
    return ''
  }
  if(label.includes(period)) {
    return label
  }
  return label + " " + period
}

export const splitYearIntoSections = (year, numberOfSections, overrides = {}) => {
  if(!year) {
    return []
  }
  const yearStart = startOfYear(new Date(year, 0, 1));
  const yearEnd = endOfYear(new Date(year, 0, 1));
  const totalMonths = differenceInMonths(yearEnd, yearStart) + 1; // 12 months
  const monthsPerSection = Math.floor(totalMonths / numberOfSections);

  const sections = [];

  for (let i = 0; i < numberOfSections; i++) {
    const sectionStart = addMonths(yearStart, i * monthsPerSection);
    const sectionEnd =
      i === numberOfSections - 1
        ? yearEnd
        : endOfMonth(addMonths(sectionStart, monthsPerSection - 1));
    const period = `${i + 1}`
    sections.push({
      ...overrides,
      year: `${year}`,
      label: createLabel(overrides?.label, period),
      start: sectionStart.toISOString(),
      end: sectionEnd.toISOString(),
      period
    });
  }

  return sections;
};
export function sortSessions(dates = []) {
  return dates.sort((a, b) => {
    const yearA = parseInt(a.year);
    const yearB = parseInt(b.year);
    if (yearA !== yearB) return yearA - yearB;

    const periodA = parseInt(a.period || 0);
    const periodB = parseInt(b.period || 0);
    if (periodA !== periodB) return periodA - periodB;

    // Fallback to date comparison (same field types only)
    const dateA = new Date(a.start || a.formsOpenDate || 0);
    const dateB = new Date(b.start || b.formsOpenDate || 0);
    return dateA - dateB;
  });
}